module.exports = __webpack_public_path__ + "static/FloatingFile-3-dark-90db8e9c33b5300ad9678a7639e26dd8.svg";